/**
 * @param {object} raw  /api/v1/locations item
 * @returns {import('@core/types').Location}
 */
export function toLocation(raw) {
  const latitude = raw.latitude ?? null;
  const longitude = raw.longitude ?? null;
  return {
    id: raw.location_id ?? raw.id,
    name: raw.name ?? '',
    address: raw.address ?? null,
    city: raw.address?.city ?? undefined,
    state: raw.address?.state ?? undefined,
    country: raw.address?.country ?? undefined,
    latitude: latitude != null ? Number(latitude) : undefined,
    longitude: longitude != null ? Number(longitude) : undefined,
    currencyCode: raw.currency_code ?? undefined,
    isActive: raw.is_active ?? true,
    isApproved: raw.is_approved ?? true,
    deliveryAvailable: raw.delivery_details?.delivery_available ?? false,
    pickupAvailable: raw.delivery_details?.pickup_available ?? false,
    deliverySlots: raw.delivery_details?.delivery_slots ?? raw.delivery_slots ?? null,
    timings: raw.timings ?? [],
    supportContact: raw.support_contact ?? null,
    raw,
  };
}
